import React, { createContext, useState } from "react";

import { ITemplateItem } from "types/query/template";

interface ModalState {
  content?: boolean;
  threadImport?: boolean;
  stack?: boolean;
  automation?: boolean;
  mfa?: boolean;
  disableMfa?: boolean;
  trigger?: boolean | string | number;
  createTemplate?: boolean | "update";
  chooseTemplate?: boolean | "update";
  updateTemplateVariables?: boolean;
  profileModal?: boolean;
  switchToJourneys?: boolean;
  pastDueInvoice?: boolean;
  duplicateJourneys?: boolean;
  deleteJourneys?: boolean;
  convertToApp?: boolean;
  cancelSubscription?: boolean;
  nameJourneyVersion?: boolean;
  restoreJourneyVersion?: boolean;
  modalProps?: {
    template?: Partial<ITemplateItem> | null;
    onComplete?: () => void;
  } | null;
}

export type ModalTypes = keyof ModalState;

export interface ModalContext extends ModalState {
  updateModal: (type: ModalTypes, value?: boolean | string | number, modalProps?: ModalState["modalProps"]) => any;
  replaceModal: (
    prev: ModalTypes,
    current: ModalTypes,
    value?: boolean | string | number,
    modalProps?: ModalState["modalProps"]
  ) => any;
}

export const ModalContext = createContext<ModalContext>({
  updateModal: () => {},
  replaceModal: () => {},
});

interface ModalProviderProps {
  children: React.ReactNode;
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [state, setState] = useState<ModalState>({
    content: false,
    threadImport: false,
    stack: false,
    automation: false,
    mfa: false,
    disableMfa: false,
    trigger: false,
    createTemplate: false,
    chooseTemplate: false,
    updateTemplateVariables: false,
    profileModal: false,
    switchToJourneys: false,
    cancelSubscription: false,
    nameJourneyVersion: false,
    restoreJourneyVersion: false,
  });

  const updateModal = (
    type: ModalTypes,
    value?: boolean | string | number,
    modalProps: ModalState["modalProps"] = null
  ) => {
    const isBooleanState = typeof state[type] === "boolean";

    setState({
      ...state,
      modalProps,
      [type]: value ?? (isBooleanState ? !state[type] : false),
    });
  };

  const replaceModal = (
    prev: ModalTypes,
    current: ModalTypes,
    value?: boolean | string | number,
    modalProps: ModalState["modalProps"] = null
  ) => {
    const isBooleanState = typeof state[current] === "boolean";

    setState({
      ...state,
      modalProps,
      [prev]: false,
      [current]: value ?? (isBooleanState ? !state[current] : false),
    });
  };

  return (
    <ModalContext.Provider
      value={{
        updateModal,
        replaceModal,
        ...state,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
